import { ApiService } from "Services/ApiService";
import { ResultsDTO } from "Types/ResultsDTO";
import { decodeParamList } from "Utilities/urlEncoder";

export interface ActiveAuthor {
  id: number;
  author: string;
  isActive: string;
}

interface AuthorsByCategoryResult {
  authorCount: number;
  authors: string[];
}

export const activeAuthorApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllActiveAuthors: builder.query<ActiveAuthor[], void>({
      query: () => ({
        url: "author/active-authors",
        method: "GET",
      }),
      transformResponse: (res: ResultsDTO<ActiveAuthor[]>) => res.results ?? [],
      providesTags: [{ type: "Author", id: "ACTIVE_LIST" }],
    }),
    getActiveAuthorsByProductType: builder.query<ActiveAuthor[], string>({
      query: (productType) => ({
        url: "author/active-authors-by-product-type",
        method: "GET",
        params: { productType },
      }),
      transformResponse: (res: ResultsDTO<ActiveAuthor[]>) => res.results ?? [],
      providesTags: (result, error, productType) => [
        { type: "Author", id: `ACTIVE_LIST_${productType}` },
      ],
    }),
    getAuthorsByCategory: builder.query<
      string[],
      { categoryId: string; productType?: string }
    >({
      query: ({ categoryId, productType }) => {
        let decodedProductType = productType;
        if (decodedProductType) {
          decodedProductType = decodeParamList(decodedProductType).map(v => v.toUpperCase()).join(",");
        }
        return {
          url: "author/by-category",
          params: decodedProductType ? { categoryId, productType: decodedProductType } : { categoryId },
        };
      },
      transformResponse: (res: ResultsDTO<AuthorsByCategoryResult>) =>
        res.results?.authors ?? [],
      providesTags: (result, error, { categoryId }) => [
        { type: "Author", id: `CATEGORY_${categoryId}` },
      ],
    }),
  }),
});

export const {
  useGetAllActiveAuthorsQuery,
  useGetActiveAuthorsByProductTypeQuery,
  useGetAuthorsByCategoryQuery,
} = activeAuthorApiSlice;
